import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
// import 'vue-awesome/css/vue-awesome.min.css'

import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import _ from 'lodash'
import 'vue-awesome/icons'
import Icon from 'vue-awesome/components/Icon.vue'

Vue.component('icon', Icon)

Vue.use(BootstrapVue)
Vue.use(VueRouter)
Vue.use(_)

var router = new VueRouter({
  mode: 'history',
  routes: []
})

new Vue({
  router,
  el: '#app',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js